<!-- Route / navigation loading indicator -->
@if (isNavigating()) {
  <div aria-hidden="true" class="fixed top-0 left-0 right-0 z-[70] h-0.5 overflow-hidden">
    <div class="route-loading-bar h-full w-1/2 bg-[var(--reader-accent)] opacity-90 rounded-r-full"></div>
  </div>
}

<app-navbar />

<main class="relative min-h-[calc(100vh-3.5rem-72px)] bg-[--reader-surface] transition-colors duration-300"
      [@routeAnimation]="getRouteAnimData(outlet)">
  <router-outlet #outlet="outlet" />
</main>

<app-footer />

<!-- Theme customiser panel -->
<app-theme-customizer />
